<template>
  <div class="business-info" id="businessInfo">
    <van-popover
      v-model="showPopover"
      get-container="#businessInfo"
      :class="{ companyInformation: true, companyStyle: companyStyle }"
      :close-on-click-outside="true"
      :close-on-click-action="true"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad(false)"
      >
        <div class="list">
          <div
            v-for="(item, index) in list"
            :key="item.name + index"
            class="list-item"
            @click="confirm(item.name, item.exists)"
          >
            <span v-html="getCustomerName(item.name)"></span>
            <van-icon
              v-if="isShowExist && item.exists"
              class="companyInformation-exist-icon"
              :name="existIcon"
            />
          </div>
        </div>
      </van-list>
      <template #reference>
        <van-field
          clearable
          label="|"
          :left-icon="practice1"
          placeholder="请输入您的单位名称"
          type="text"
          input-align="left"
          v-model="inputValue"
          @focus="focus"
          @blur="blur"
          @input="onLoad(true)"
        />
      </template>
    </van-popover>
  </div>
</template>

<script>
import { queryCompanyName } from "../../api/form";
export default {
  name: "Businessnformation",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: { type: String, default: "" },
    isShowExist: { type: Boolean, default: false },
    isClear: { type: Boolean },
  },
  watch: {
    value: {
      handler(n) {
        this.inputValue = n;
      },
      deep: true,
    },
    isClear() {
      this.clear();
    },
  },
  data() {
    return {
      showPopover: false, // 是否显示弹框
      loading: false,
      finished: true,
      list: [],
      existIcon: "",
      inputValue: "",
      current: 1,
      size: 500,
      total: 0,
      nameIsExist: false,
      practice1: require("../../assets/img/phoneHomePage/practice-1.png"),
      companyStyle: false,
    };
  },
  methods: {
    // 列表加载
    onLoad(isFresh) {
      const self = this;
      const value = self.inputValue;
      self.nameIsExist = false;
      if (value === "") {
        self.showPopover = false;
        self.list = [];
        self.loading = false;
        self.finished = true;
        return;
      } else {
        self.showPopover = true;
        self.loading = true;
        self.finished = false;
      }
      if (isFresh) {
        self.current = 1;
        self.list = [];
      }
      queryCompanyName({ word: value })
        .then((res) => {
          if (res.status === "200" || res.status === 200) {
            self.list = self.list.concat(res.data.result.items || []);
            self.total = res.data.result.total || 0;
            if (self.current * self.size >= self.total) {
              self.finished = true;
            }
            self.current += 1;
            self.loading = false;
          } else {
            self.finished = true;
            self.loading = false;
          }
        })
        .catch((res) => {
          self.finished = true;
          self.loading = false;
        });
    },
    // 搜索关键字显示特殊颜色
    getCustomerName(name) {
      const self = this;
      const index = name.indexOf(self.inputValue);
      if (index !== -1) {
        let prefix = name.substring(0, index);
        let key = self.inputValue;
        let end = name.substring(index + key.length, name.length);
        return `${prefix}<span style="color: #008AFF;">${key}</span>${end}`;
      } else {
        return name;
      }
    },
    // 点击选择选项
    confirm(name, exists) {
      const self = this;
      self.inputValue = name;
      self.showPopover = false;
      self.list = [];
      self.finished = true;
      self.loading = false;
      self.nameIsExist = exists;
      self.$emit("getName", { value: self.inputValue });
    },
    // 获取焦点
    focus() {
      const self = this;
      self.$emit("focus");
    },
    // 失去焦点
    blur() {
      const self = this;
      self.companyStyle = true;
      self.nameIsExist = false;
    },
    // 关闭时清空数据
    clear() {
      this.inputValue = "";
      this.companyStyle = false;
    },
  },
  mounted() {
    this.inputValue = this.value;
  },
};
</script>

<style scoped>
.companyInformation.van-popover__wrapper {
  width: 100%;
  display: flex;
}
/deep/ .van-popover__content .van-list__finished-text,
/deep/ .van-popover__content .van-loading.van-loading--circular {
  background: #fcf3e2;
}
.van-popover .list-item {
  width: 100%;
  line-height: 33px;
  padding: 0 16px;
  position: relative;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
  text-align: left;
  background: #fcf3e2;
}
.van-popover .list-item::after {
  content: "";
  width: calc(100% - 32px);
  height: 1px;
  background: #eeeeee;
  bottom: 0;
  left: 16px;
  position: absolute;
}
.companyInformation-exist-icon {
  position: absolute;
  right: 16px;
  top: 9px;
  font-size: 16px;
}
/deep/ .van-popover {
  width: 100%;
  left: 0 !important;
  height: calc(100% - 200px);
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  background: #fcf3e2;
  box-shadow: 5px 5px 5px #eeeeee;
}
/deep/ .van-popover--light .van-popover__content {
  box-shadow: none;
}
.van-cell {
  padding: 10px 7px;
}
.van-cell.van-field {
  border: #f3f0f0 solid 1px !important;
  margin: 15px 10px 0 10px;
  width: calc(100% - 20px);
  align-items: center;
}
/deep/ .van-field__control {
  color: #323233;
}

/deep/ .companyStyle .van-field__control::placeholder {
  color: #ee0a24;
}
/deep/ .van-field__control::placeholder {
  /* color: #888; */
  font-size: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/include/Businessnformation.vue